<template>
  <div>
    <!-- 产品组件 -->
    <el-select
      v-model="selectval"
      placeholder="请输入产品名称查询"
      remote
      :remote-method="remoteMethod"
      clearable
      collapse-tags-tooltip 
      :max-collapse-tags="1"
      :loading="loading"
      filterable
      v-bind="attrs"
    >
      <el-option v-if="showAll" label="全部" value="" />
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item[label]"
        :value="item[value]"
        @click.native="slectInfo(item)"
      />
    </el-select>
  </div>
</template>

<script setup>
import { getList } from "@/api/product/index";
import { debounce } from "lodash";
const props = defineProps({
  modelValue: {
    type: [String,Array],
    require: true,
    default: undefined,
  },
  label: {
    type: String,
    default: "productName",
  },
  value: {
    type: String,
    default: "id",
  },
  showAll:{
    type:Boolean,
    default:false
  },
  status:{
      type:String,
      default:"", //启用 //禁用
  }
});

const emits = defineEmits(["update:modelValue","getInfo"]);
const attrs = useAttrs();

const list = ref([]); // 列表
const loading = ref(false)
const selectval = computed({
  get() {
    return props.modelValue ?? "";
  },
  set(val) {
    emits("update:modelValue", val);
  },
});

const remoteMethod = debounce(async (query) => {
  if (query) {
    const queryParams = {
      pageNum: 1,
      pageSize: 50,
      productName: query,
      status:props.status
    };
    loading.value = true;
    const res = await getList(queryParams);
    if (res.code == 200) {
      list.value = res.rows;
    }
    loading.value = false;
  }
}, 300);
const slectInfo = (item)=>{
  emits('getInfo',item)
}
</script>

<style lang="scss" scoped></style>
